'use strict';

var ServiceAnalysisGridDirective = function ServiceAnalysisGridDirective() {
  return {
    restrict: 'E',
    template: require('../templates/service-analysis-grid.html'),
    controller: 'ServiceAnalysisGridController',
    scope: {
      mode: '=',
      screen: '=',
      filterData: '=',
      isDemandManagement: '=?',
      retrieveDataOnInit: '=',
      reoptPreviewData: '=',
      demandManagementData: '=',
      confirmAdjustmentsClearOnRefresh: '=?'
    }
  };
};
ServiceAnalysisGridDirective.$inject = [];
module.exports = ServiceAnalysisGridDirective;